<div class="mt-auto mb-auto p-2">
  <a rel="external" target="_blank" href="https://www.linkedin.com/in/akchappell/"
    aria-label="Link to my LinkedIn profile"><i class="fab fa-linkedin-in fa-2x p-1"></i></a>
  <a rel="external" target="_blank" href="https://twitter.com/achappell_94" aria-label="Link to my Twitter profile"><i
      class="fab fa-twitter fa-2x p-1"></i></a>
  <a rel="external" target="_blank" href="https://github.com/admchppll" aria-label="Link to my GitHub profile"><i
      class="fab fa-github fa-2x p-1"></i></a>
</div>
